/**
 * DomainFeatureRoute
 *
 * Route guard for /domains/* . Redirects to /dashboard when the
 * domain-registration feature flag is OFF. Renders nothing while flags are
 * still loading — useFeatureFlags() defaults to disabled (opt-in policy),
 * so deciding before the query resolves would redirect away from a deep
 * link even when the flag is actually enabled.
 */
import { Navigate, Outlet } from "react-router-dom";
import {
  useFeatureFlags,
  useDomainRegistrationEnabled,
} from "@/hooks/useFeatureFlags";

export function DomainFeatureRoute() {
  const { isLoading } = useFeatureFlags();
  const domainsEnabled = useDomainRegistrationEnabled();

  if (isLoading) {
    return null;
  }

  if (!domainsEnabled) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
